export default __webpack_public_path__ + "static/media/Service legal-services.ce8245c0.jpg";